import { render, staticRenderFns } from "./TermsConditionList.vue?vue&type=template&id=1c1fb37c"
import script from "./TermsConditionList.vue?vue&type=script&lang=js"
export * from "./TermsConditionList.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports